import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5851c6fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, "GWT-4PL自送站点服务范围", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_download_outlined = _resolveComponent("download-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_a_row, {
          justify: "end",
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              disabled: _ctx.$store.state.loading.loading,
              onClick: _ctx.handleExport
            }, {
              default: _withCtx(() => [
                (_ctx.$store.state.loading.loading)
                  ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_download_outlined),
                _createTextVNode(" 导出自送站点服务范围 ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { style: {"margin-top":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              style: {"width":"100%"},
              columns: _ctx.columns,
              dataSource: _ctx.list,
              loading: _ctx.loading,
              size: "small"
            }, {
              bodyCell: _withCtx(({column, text, record}) => [
                (column.dataIndex === 'stationProvince')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'stationProvince')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'stationCity')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'stationCity')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'businessCycle')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'businessCycle')) + " " + _toDisplayString(record.businessStartTime) + " : " + _toDisplayString(record.businessEndTime), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'status')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(" 自送 ")
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "dataSource", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}